import { Component, inject, Input, ViewChild } from '@angular/core';
import { PurchaseOrder } from '../../../models/purchase-order/purchase-order.model';
import { DocumentPreviewComponent } from '@peca/commons';
import { PurchaseOrderService } from '../../../services/purchase.service';
import { getPurchaseOrderInvoiceLabel } from '../../../utils/purchase-order-invoice-status.utils';

@Component({
  selector: 'peca-purchase-order-details-summary[order]',
  templateUrl: './purchase-order-details-summary.component.html',
  styleUrls: ['./purchase-order-details-summary.component.scss'],
  standalone: false,
})
export class PurchaseOrderDetailsSummaryComponent {
  @Input()
  order!: PurchaseOrder;

  @ViewChild('documentPreview')
  documentPreview!: DocumentPreviewComponent;

  service: PurchaseOrderService = inject(PurchaseOrderService);

  onClickPreviewInvoice(order: PurchaseOrder) {
    if (!order.id) return;
    this.service.dowloadInvoice(order.id).subscribe((res) => {
      this.documentPreview.open({ id: order.id, title: order.order?.commerceReference || '', type: `application/pdf`, url: res });
    });
  }

  get invoiceStatus() {
    return getPurchaseOrderInvoiceLabel(this.order);
  }
}
